<template>
  <div class="c-retarget">
    <Spin size="large" fix v-if="loading" />
    <Row :gutter="12">
      <Col span="4" class-name="c-retarget-box" style="margin-left: 6px">
        <div class="c-retarget-head g-clearfix">
          <span>账号</span>
        </div>
        <div class="c-selecter-content">
          <div v-for="(item, index) in accounts" :key="item.id" :class="itemClasses(index)" @click.stop="handleAccount(item, index)">
            <div class="c-item">
              <span>{{ item.name }}</span>
              <Icon type="ios-arrow-forward" class="c-check-arrow" size="14" color="#c1c1c1" />
            </div>
          </div>
        </div>
      </Col>
      <Col span="18" style="padding: 0">
        <div class="c-retarget-box">
          <div class="c-retarget-head g-clearfix">
            <span>应用标记</span>
            <span class="c-retarget-title">选择</span>
            <span class="c-retarget-title">应用名称</span>
            <span class="c-retarget-title">应用ID</span>
          </div>
          <Input v-model="search" suffix="ios-search" placeholder="请输入关键词" style="width: calc(100% - 11px); margin: 5px" />
          <div class="c-retartget-content" style="overflow-y: scroll">
            <div class="c-check-item g-clearfix" v-for="item in list" :key="item.id">
              <span class="item-span">{{ item.real_app_name }}</span>
              <span class="item-type">{{ item.app_id }}</span>
              <Tooltip trigger="hover" :content="item.app_name" placement="top-start" :max-width="260">
                <span class="item-type">{{ item.real_app_name }}</span>
              </Tooltip>
              <RadioGroup v-model="item.select" style="float: right; height: 36px">
                <Radio label="include" />
              </RadioGroup>
            </div>
          </div>
        </div>
      </Col>
    </Row>
  </div>
</template>
<script>
import { getAppList } from '@/api/kuaishou.model'
import { isArray, timeout } from '@/common/js/utils'

export default {
  name: 'retarget',
  props: {
    data: {
      type: Array
    },
    accounts: {
      type: Array
    },
    currenTab: {
      type: String,
      default() {
        return 'include'
      }
    }
  },
  computed: {
    list() {
      return this.data.filter((ret) => ret.real_app_name.indexOf(this.search) > -1)
    },
    includes() {
      return this.data.filter((ret) => ret.select === 'include')
    },
    itemClasses() {
      return (item) => {
        const cls = ['m-account']
        item === this.current && cls.push('active')
        return cls
      }
    }
  },
  methods: {
    handleClose(event, name) {
      this.$emit('on-delete', { list: this.data, name })
    },
    handleAccount({ id }, index) {
      this.current = index
      this.getAppList(id)
    },
    getAppList(id) {
      this.loading = true
      getAppList({ ad_account_id: id }).then((data) => {
        timeout(200).then(() => {
          this.loading = false
        })
        if (isArray(data)) {
          const iOSAppData = data.filter((ret) => ret.platform === 'ios')
          this.$emit('on-change', { id, index: this.current, iOSAppData })
        }
      })
    }
  },
  data() {
    return {
      loading: null,
      search: '',
      current: 0
    }
  }
}
</script>
<style lang="scss" scoped>
.c-retarget-box {
  position: relative;
  background-color: #fafbfe;
  border: solid 1px #dee4f5;
  padding: 0 !important;

  .c-retarget-head {
    padding: 0 8px;
    height: 34px;
    color: #333;
    border-bottom: solid 1px #dee4f5;

    span {
      height: 34px;
      font-size: 12px;
      line-height: 34px;
      vertical-align: middle;
      margin-left: 8px;
    }

    .c-retarget-title {
      float: right;
      font-size: 12px;
      margin-right: 14px;
    }
  }

  .c-retarget-h {
    height: 285px !important;
  }

  .c-retartget-content,
  .c-retarget-result {
    overflow-y: auto;
    scrollbar-width: thin;
    -webkit-overflow-scrolling: touch;
    height: 246px;
    background-color: #fff;

    .c-check-item {
      margin: 0;
      padding-left: 12px;
      display: block;
      position: relative;
      height: 36px;
      line-height: 36px;
      cursor: pointer;

      &:hover {
        background-color: #f8f8f8;
      }

      .ivu-radio-wrapper {
        min-width: inherit;
        text-align: right;
        font-size: 0;
        margin-right: 14px;
      }

      .item-span {
        width: calc(100% - 186px);
        display: inline-block;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }

      .item-type {
        text-align: right;
        display: inline-block;
        width: 60px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }

      .item-id {
        min-width: 60px;
        margin-right: 10px;
      }
    }
  }

  .c-selecter-content {
    height: 288px;
    padding-bottom: 8px;

    .m-account {
      padding: 8px 8px;
      display: flex;

      &:hover {
        background-color: #f8f8f8;
      }

      &.active {
        color: #598fe6;
        background-color: #f8f8f8;

        .c-check-arrow {
          color: #598fe6 !important;
        }
      }
    }

    .c-item {
      width: 100%;
      position: relative;
      z-index: 5;
      display: flex;
      justify-content: flex-start;
      align-items: center;

      span {
        width: calc(100% - 18px);
        line-height: 20px;
      }
    }
  }

  .c-retarget-result {
    padding-bottom: 8px;
  }
}

.c-tag-item {
  margin: 8px 12px 0;
  padding: 2px 6px;
  display: block;
  font-size: 14px;
  height: 28px;
}
</style>
